import { http, HttpResponse, type HttpHandler } from "msw";
import { TRANSLATIONS_LOCALE_FILE_PATTERN } from "../../translations-api.js";
import { translations as algotelsTranslations } from "@holisto-web/translations/brands/algotels";
import { translations as holistoTranslations } from "@holisto-web/translations/brands/holisto";
import { translations as splittyTranslations } from "@holisto-web/translations/brands/splitty";
import { translations as traveluroTranslations } from "@holisto-web/translations/brands/traveluro";
import { translations as trivagodealsTranslations } from "@holisto-web/translations/brands/trivagodeals";
import { translations as zaptravelTranslations } from "@holisto-web/translations/brands/zaptravel";
import { cloneDeep, merge } from "lodash-es";

const translationsPerBrand: Record<
  BrandId,
  | typeof holistoTranslations.dictionary
  | typeof zaptravelTranslations.dictionary
  | typeof trivagodealsTranslations.dictionary
  | typeof splittyTranslations.dictionary
  | typeof algotelsTranslations.dictionary
  | typeof traveluroTranslations.dictionary
> = {
  holisto: holistoTranslations.dictionary,
  zaptravel: zaptravelTranslations.dictionary,
  trivagodeals: trivagodealsTranslations.dictionary,
  splitty: splittyTranslations.dictionary,
  algotels: algotelsTranslations.dictionary,
  traveluro: traveluroTranslations.dictionary,
};

export const getTranslations = (brandId: BrandId): { translations: Record<string, unknown> } => {
  return {
    translations: translationsPerBrand[brandId],
  };
};

const getLocaleCodeFromTranslationsRequest = (request: Request): string => {
  const match = request.url.match(TRANSLATIONS_LOCALE_FILE_PATTERN);
  return match?.groups?.localeCode ?? "en-US";
};

export const translationsHandlers = {
  getTranslations: [
    http.get(TRANSLATIONS_LOCALE_FILE_PATTERN, () => {
      return HttpResponse.json(getTranslations(process.env.REACT_APP_BRAND_NAME), { status: 200 });
    }),
  ],
};

export const createTranslationsHandlersWithLocaleOverrides = (
  overridesByLocaleCode: Record<string, Record<string, unknown>>,
): HttpHandler[] => [
  http.get(TRANSLATIONS_LOCALE_FILE_PATTERN, ({ request }) => {
    const localeCode = getLocaleCodeFromTranslationsRequest(request);
    const brandId = (process.env.REACT_APP_BRAND_NAME ?? "holisto") as BrandId;
    const base = cloneDeep(translationsPerBrand[brandId]) as Record<string, unknown>;
    const overrides = overridesByLocaleCode[localeCode];
    const merged = overrides ? (merge(base, overrides) as Record<string, unknown>) : base;
    return HttpResponse.json({ translations: merged }, { status: 200 });
  }),
];
